import Base from '@components/layouts/base';
import Topbar from '@components/partials/common/topbar';
import Cookie from '@components/partials/common/tos/cookie';
import Dmca from '@components/partials/common/tos/dmca';
import Privacy from '@components/partials/common/tos/privacy';
import Tos from '@components/partials/common/tos/tos';
import Usc18 from '@components/partials/common/tos/usc18';
import Header from '@components/partials/header/header';
import { getCategoryList } from '@data/category';
import { getIndexData } from '@data/index';
import { getStaticData } from '@data/staticData';
import { getTosMenuList } from '@data/tosMenuList';
import classes2 from '@styles/scss/common/_footer.module.scss';
import classes from '@styles/scss/common/_tos.module.scss';
import { IndexProps } from 'lib/types/page/indexprops';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

export default function Index({
    pageData,
    intro,
    introEmail,
    categoryList,
    tosData,
    cookieData,
    usc18Data,
    dmcaData,
    privacyData
}: {
    pageData: IndexProps;
    intro: any;
    introEmail: string;
    categoryList: any;
    tosData: any;
    cookieData: any;
    usc18Data: any;
    dmcaData: any;
    privacyData: any;
}): JSX.Element {
    if (!pageData) return <div>Loading ...</div>;
    const router = useRouter();
    const myArray = router.asPath.split('#');
    const tab = myArray[1];

    const TosComponents: any = {
        TOS: <Tos pageData={tosData} />,
        Cookie: <Cookie pageData={cookieData} />,
        USC18: <Usc18 pageData={usc18Data} />,
        DMCA: <Dmca pageData={dmcaData} />,
        privacy: <Privacy pageData={privacyData} />
    };

    const tosList: any = getTosMenuList();
    const [activeTab, setActiveTab] = useState(tab);

    const handleTab = (e: any) => {
        e.preventDefault();
        setActiveTab(e.target.id);
    };

    return (
        <>
            <Base>
                <Head>
                    <meta property="og:type" content="website" />
                    <meta property="og:url" content={pageData.canonical + 'Default.aspx'} />
                    <meta name="robots" content={pageData.metaRobots} />
                    <link rel="canonical" href={pageData.canonical} />
                </Head>
            </Base>

            <div className={classes.pWrapper + ' ' + classes.content}>
                <div className={classes.cWrapper}>
                    <Topbar categoryList={categoryList} isHomePage={false} />
                    <Header intro={intro} introEmail={introEmail} isHome={true} />
                    <div className={classes.text + ' ' + classes.tos}>
                        {/* Tab nav */}
                        {/* to do : switch to language tos menu */}
                        <div className={classes.inftabs + ' ' + classes.inftabsWrapper}>
                            {Object.keys(tosList.en).map((tosTabName: string) => {
                                return (
                                    <a
                                        href={'#' + tosList.en[tosTabName].tab}
                                        key={tosTabName}
                                        id={tosTabName}
                                        tabIndex={0}
                                        aria-label={tosTabName}
                                        className={
                                            activeTab === tosTabName
                                                ? classes.btn + ' ' + classes.active
                                                : classes.btn
                                        }
                                        onClick={(e) => handleTab(e)}>
                                        {tosTabName}
                                    </a>
                                );
                            })}
                        </div>
                        {/* Tab content */}
                        {TosComponents[activeTab]}
                    </div>
                    {/* Footer for tos */}
                    <div className={classes2.copy}>
                        {Object.keys(tosList.en).map((tosTabName: any) => {
                            return (
                                <span key={tosTabName}>
                                    <a
                                        href={'#' + tosList.en[tosTabName].tab}
                                        id={tosTabName}
                                        aria-label={tosList.en[tosTabName].title}
                                        className={classes2.inftabs + ' ' + classes2.link}
                                        data-original-title={tosList.en[tosTabName].title}
                                        onClick={(e) => handleTab(e)}>
                                        {tosList.en[tosTabName].title}
                                    </a>{' '}
                                    |{' '}
                                </span>
                            );
                        })}
                        <a
                            data-rel="tabprivacy"
                            className={classes2.inftabs + ' ' + classes2.link}
                            href={'https://www.myfavsexcams.xxx/blog/'}
                            title="Sex Cam BLOG Articles"
                            data-original-title="Blog">
                            Sex Cam BLOG Articles
                        </a>{' '}
                        | © 2022 My Fav Sex Cams - All Rights Reserved.{' '}
                    </div>
                </div>
            </div>
        </>
    );
}

export const getServerSideProps: GetServerSideProps = async () => {
    // Get the data from the respository to populate the page
    const data = await getCategoryList();
    const intro = data.intro;
    const introEmail = data.emailText;
    const categoryList = data.categoryList;
    const pageData = await getIndexData();
    const tosData = await getStaticData('tos');
    const cookieData = await getStaticData('cookie');
    const usc18Data = await getStaticData('usc18');
    const dmcaData = await getStaticData('dmca');
    const privacyData = await getStaticData('privacy');

    return {
        props: {
            pageData,
            intro,
            introEmail,
            categoryList,
            tosData,
            cookieData,
            usc18Data,
            dmcaData,
            privacyData
        }
    };
};
